export default __webpack_public_path__ + "static/media/descarca_aplicatia_zumzi_telefon.73f51275.png";